import { BaseRequestType } from "../apiService";
import { ClientMutation, ClientQuery, ClientReq, ClientVar } from "./clients";
import {
  CompanyMutation,
  CompanyQuery,
  CompanyReq,
  CompanyVar,
} from "./companies";
import {
  ContractsMutation,
  ContractsQuery,
  ContractsReq,
  ContractsVar,
} from "./contracts";
import {
  EmployeeMutation,
  EmployeeQuery,
  EmployeeReq,
  EmployeeVar,
} from "./employees";
import {
  TimelogMutation,
  TimelogQuery,
  TimelogReq,
  TimelogVar,
} from "./timelogs";
import {
  AbsenceMutation,
  AbsenceQuery,
  AbsenceReq,
  AbsenceVar,
} from "./absences";
import {
  TimeInLieuMutation,
  TimeInLieuQuery,
  TimeInLieuReq,
  TimeInLieuVar,
} from "./timeInLieus";
import {
  BankHolidayMutation,
  BankHolidayQuery,
  BankHolidayReq,
  BankHolidayVar,
} from "./bankHolidays";

export type QueryType = BaseRequestType &
  (
    | ClientQuery
    | EmployeeQuery
    | CompanyQuery
    | ContractsQuery
    | TimelogQuery
    | AbsenceQuery
    | TimeInLieuQuery
    | BankHolidayQuery
  );

export type MutationType = BaseRequestType &
  (
    | ClientMutation
    | EmployeeMutation
    | CompanyMutation
    | ContractsMutation
    | TimelogMutation
    | AbsenceMutation
    | TimeInLieuMutation
    | BankHolidayMutation
  );

export type ReqType<T> = T extends ClientQuery | ClientMutation
  ? ClientReq<T>
  : T extends EmployeeQuery | EmployeeMutation
  ? EmployeeReq<T>
  : T extends CompanyQuery | CompanyMutation
  ? CompanyReq<T>
  : T extends ContractsQuery | ContractsMutation
  ? ContractsReq<T>
  : T extends TimelogQuery | TimelogMutation
  ? TimelogReq<T>
  : T extends AbsenceQuery | AbsenceMutation
  ? AbsenceReq<T>
  : T extends TimeInLieuQuery | TimeInLieuMutation
  ? TimeInLieuReq<T>
  : T extends BankHolidayQuery | BankHolidayMutation
  ? BankHolidayReq<T>
  : never;

export type VarType<T> = T extends ClientMutation
  ? ClientVar<T>
  : T extends EmployeeMutation
  ? EmployeeVar<T>
  : T extends CompanyMutation
  ? CompanyVar<T>
  : T extends ContractsMutation
  ? ContractsVar<T>
  : T extends TimelogMutation
  ? TimelogVar<T>
  : T extends AbsenceMutation
  ? AbsenceVar<T>
  : T extends TimeInLieuMutation
  ? TimeInLieuVar<T>
  : T extends BankHolidayMutation
  ? BankHolidayVar<T>
  : never;
